import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconNavigationArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	fill: "none",
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M8.5 2.667l-.94.94 3.72 3.726H3.167v1.334h8.113l-3.72 3.726.94.94L13.833 8 8.5 2.667z"
	})
});
export default SvgIconNavigationArrowRight;
